<!-- Mobile header — visível apenas em telas pequenas -->
<header class="mobile-header">
  <button
    class="mobile-hamburger"
    type="button"
    aria-label="Abrir menu"
    (click)="toggleMobileMenu()">
    <i class="pi" [ngClass]="mobileMenuOpen ? 'pi-times' : 'pi-bars'"></i>
  </button>
  <div class="mobile-spacer"></div>
  <div class="mobile-brand">
    <img src="assets/manager-favicon.svg" alt="iManager" class="mobile-brand-icon" />
    <span class="mobile-brand-name"><span class="mobile-brand-i">i</span>Manager</span>
  </div>
</header>

<!-- Backdrop mobile -->
<div
  class="mobile-backdrop"
  [class.is-visible]="mobileMenuOpen"
  (click)="closeMobileMenu()">
</div>

<div class="shell">
  <aside class="sider" [class.mobile-open]="mobileMenuOpen">
    <app-shared-menu
      (logout)="openLogoutDialog()"
      (navClicked)="closeMobileMenu()">
    </app-shared-menu>
  </aside>

  <main class="content">
    <div class="content-card">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<!-- Modal de confirmação de logout -->
<p-dialog
  [(visible)]="showLogoutDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
  styleClass="logout-dialog"
  (onHide)="cancelLogout()">

  <ng-template pTemplate="header">
    <div class="logout-dialog__header">
      <div class="logout-dialog__icon-wrap">
        <i class="pi pi-sign-out"></i>
      </div>
      <div class="logout-dialog__title-group">
        <span class="logout-dialog__title">Sair do sistema</span>
        <span class="logout-dialog__subtitle">Encerrar sua sessão atual</span>
      </div>
    </div>
  </ng-template>

  <div class="logout-dialog__body">
    <p class="logout-dialog__message">
      Tem certeza que deseja sair? Você precisará fazer login novamente para acessar o sistema.
    </p>
  </div>

  <div class="logout-dialog__footer">
    <button
      type="button"
      class="logout-dialog__btn logout-dialog__btn--cancel"
      (click)="cancelLogout()">
      Cancelar
    </button>
    <button
      type="button"
      class="logout-dialog__btn logout-dialog__btn--confirm"
      (click)="confirmLogout()">
      <i class="pi pi-sign-out"></i>
      Sair
    </button>
  </div>
</p-dialog>
